export default __webpack_public_path__ + "static/media/chevron-left.56e720db.svg";